import { render, staticRenderFns } from "./DocumentAwards.vue?vue&type=template&id=8a5de334&scoped=true"
import script from "./DocumentAwards.vue?vue&type=script&lang=js"
export * from "./DocumentAwards.vue?vue&type=script&lang=js"
import style0 from "./DocumentAwards.vue?vue&type=style&index=0&id=8a5de334&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a5de334",
  null
  
)

export default component.exports